import { Navigate } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectPage = () => {
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()

  const isExternalUser = employee?.affiliation === 'external'

  if (isExternalUser) {
    return <Navigate replace to={navigation.inbox.requests.fullPath()} />
  }

  return <Navigate replace to={navigation.inbox.todo.fullPath()} />
}

export default RedirectPage
